export const Roles = {
  individual: "INDIVIDUAL",
  business: "BUSINESS",
  companyMember: "COMPANY_MEMBER"
};
